var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.375 9.208V8.5c0-1.172.953-2.125 2.125-2.125h.708v-2.36a.473.473 0 00-.472-.473H4.014a.473.473 0 00-.472.472v4.722c0 .26.211.472.472.472h2.361zm0 1.417h-2.36a1.89 1.89 0 01-1.89-1.89v-4.72a1.89 1.89 0 011.89-1.89h4.72a1.89 1.89 0 011.89 1.89v2.36h2.125c1.172 0 2.125.953 2.125 2.125v4.25a2.128 2.128 0 01-2.125 2.125H8.5a2.128 2.128 0 01-2.125-2.125v-2.125zM7.792 8.5a.71.71 0 01.708-.708h4.25c.391 0 .708.318.708.708v4.25c0 .39-.317.708-.708.708H8.5a.71.71 0 01-.708-.708V8.5z",
    fill: "current"
  })));
}
export default SvgCopy;